// src/utils/awsRedirectPrevention.js
// Prevents AWS Cognito Hosted UI from hijacking the app with stale auth params

const AWS_COGNITO_PARAMS = ["code", "state", "session_state", "error", "error_description"];

const hasAWSParams = () => {
  const params = new URLSearchParams(window.location.search);
  return AWS_COGNITO_PARAMS.some((p) => params.has(p));
};

const clearAWSParams = () => {
  if (!hasAWSParams()) return;
  const clean = window.location.pathname;
  window.history.replaceState({}, document.title, clean);
  console.log("awsRedirectPrevention - Cleared AWS auth params from URL");
};

export const clearAllAWSState = () => {
  Object.keys(localStorage).forEach((key) => {
    if (
      key.includes("CognitoIdentityServiceProvider") ||
      key.includes("amplify") ||
      key.includes("aws-amplify")
    ) {
      localStorage.removeItem(key);
    }
  });
  clearAWSParams();
};

export const preventAWSRedirects = () => {
  clearAWSParams();

  const handlePopState = () => clearAWSParams();
  window.addEventListener("popstate", handlePopState, { passive: true });

  return () => window.removeEventListener("popstate", handlePopState);
};
